/* eslint-disable no-console */
import { isEqual } from 'lodash-es';
import { decodeHtml } from './decode';

export const isObjectDifferent = (
  input: Record<string, any>,
  compareTo: Record<string, any>,
  ignoreSubObjects?: boolean,
  logIt?: boolean,
): boolean => (
  Object
    .keys(input)
    .some((key) => {
      if (typeof input[key] !== typeof compareTo[key]) return true;

      if (typeof input[key] === 'number' || typeof compareTo[key] === 'number') {
        if (logIt) console.log('--> COMPARE TYPE: number', key, `${input[key] || null}`, `${compareTo[key] || null}`);
        return `${input[key]}` !== `${compareTo[key]}`;
      }

      if (typeof input[key] === 'object' || typeof compareTo[key] === 'object') {
        if (logIt) console.log('--> COMPARE TYPE: object', key, input[key], compareTo[key]);
        return !ignoreSubObjects ? !isEqual(input[key], compareTo[key]) : false;
      }

      if (
        (typeof input[key] === 'string' && input[key]?.includes('&gt;'))
      && (typeof compareTo[key] === 'string' && compareTo[key]?.includes('&gt;'))
      ) {
        const decodedInput = decodeHtml(input[key] ?? '', true);
        const decodedCompareTo = decodeHtml(compareTo[key] ?? '', true);
        const matches = (decodedInput.match(/<.+?>/g) ?? []).filter((m) => ['<br/>, <br>'].includes(m.toLowerCase()));
        const cleanedInput = matches
          .reduce((acc, cur) => acc.replace(new RegExp(cur, 'g'), ''), decodedInput)
          .trim();
        const cleanedCompareTo = matches
          .reduce((acc, cur) => acc.replace(new RegExp(cur, 'g'), ''), decodedCompareTo)
          .trim();

        if (logIt) {
          console.log({
            CompareType: 'html',
            key,
            original: cleanedInput,
            compareTo: cleanedCompareTo,
          });
        }

        return cleanedInput !== cleanedCompareTo;
      }

      if (logIt) {
        console.log('--> COMPARE TYPE: other', key, `${input[key] || null}`, `${compareTo[key] || null}`);
      }
      return `${(input[key] || null)}` !== `${(compareTo[key] || null)}`;
    })
);
